export interface ApiUser {
  id: number;
  name: string;
  email: string;
  role: string;
  can_upload: boolean;
  can_query: boolean;
  can_manage_users: boolean;
}

export interface ApiSession {
  token: string;
  user: ApiUser;
}

const SESSION_KEY = 'API_AUTH_SESSION';
const API_BASE_URL = 'https://api-jurisai.polykloud.com/api';

export async function signInApiUser(email: string, password: string): Promise<ApiSession> {
  try {
    const response = await fetch(`${API_BASE_URL}/auth/demo-login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, password }),
    });

    const data = await response.json();

    if (!response.ok || !data.success) {
      throw new Error(data.error || 'Authentication failed');
    }

    const session: ApiSession = {
      token: data.token,
      user: data.user,
    };

    localStorage.setItem(SESSION_KEY, JSON.stringify(session));
    return session;
  } catch (error) {
    console.error('Authentication error:', error);
    throw error;
  }
}

export function getCurrentSession(): ApiSession | null {
  try {
    const raw = localStorage.getItem(SESSION_KEY);
    if (!raw) return null;
    const session = JSON.parse(raw) as ApiSession;
    return session;
  } catch {
    return null;
  }
}

export function signOutApiUser(): void {
  localStorage.removeItem(SESSION_KEY);
}

// No more reset functionality - users are managed in database
export function resetApiUsers(): void {
  console.log('User management is now handled by the database. No reset needed.');
}
